export default __webpack_public_path__ + "static/media/hand_phone.64a6c1d1.webp";